/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description External
 */

export enum External {
  FALSE = 0,
  SITE = 1,
  NO_DETAIL = 2,
}

Object.defineProperty(External, '__ENUM_NAME', {
  value: 'External',
  writable: false,
  configurable: false,
  enumerable: false,
})
